/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '../../assets/sass/checkout/checkout.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '../../../app/checkout/checkout.component';
import * as import4 from '../../../app/services/breadcrumbs.service';
const styles_CheckoutComponent:any[] = [import0.styles];
export const RenderType_CheckoutComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_CheckoutComponent,
  data: {}
}
);
export function View_CheckoutComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),10,'div',[
      [
        'class',
        'page-wrapper'
      ]
      ,
      [
        'style',
        'width: 100vw'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'main',[
      [
        'class',
        'main'
      ]
      ,
      [
        'id',
        'checkout'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[
      [
        'class',
        'container'
      ]
      ,
      [
        'style',
        'background-color: #fcfcfc;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(147456,(null as any),0,import2.RouterOutlet,[
      import2.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_CheckoutComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-checkout',([] as any[]),(null as any),(null as any),(null as any),View_CheckoutComponent_0,RenderType_CheckoutComponent)),
    import1.ɵdid(114688,(null as any),0,import3.CheckoutComponent,[import4.BreadcrumbsService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const CheckoutComponentNgFactory:import1.ComponentFactory<import3.CheckoutComponent> = import1.ɵccf('app-checkout',import3.CheckoutComponent,View_CheckoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jaGVja291dC9jaGVja291dC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9zcmMvYXBwL2NoZWNrb3V0L2NoZWNrb3V0LmNvbXBvbmVudC50cyIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jaGVja291dC9jaGVja291dC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9jaGVja291dC9jaGVja291dC5jb21wb25lbnQudHMuQ2hlY2tvdXRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwicGFnZS13cmFwcGVyXCIgc3R5bGU9XCJ3aWR0aDogMTAwdndcIj5cbiAgPG1haW4gaWQ9XCJjaGVja291dFwiIGNsYXNzPVwibWFpblwiPlxuICAgIDxkaXYgY2xhc3M9XCJjb250YWluZXJcIiBzdHlsZT1cImJhY2tncm91bmQtY29sb3I6ICNmY2ZjZmM7XCI+XG4gICAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gICAgPC9kaXY+XG4gIDwvbWFpbj5cbjwvZGl2PlxuIiwiPGFwcC1jaGVja291dD48L2FwcC1jaGVja291dD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQStDO0lBQzdDO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUFpQztJQUMvQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFBMEQ7SUFDeEQ7Z0JBQUE7Ozs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQStCO0lBQzNCO0lBQ0Q7SUFDSDs7Ozs7O0lDTk47Z0JBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/checkout/checkout.component.ngfactory.ts